import { getFetch } from '@legacy/utils/fetcher';
import { useQuery } from '@tanstack/react-query';
import { concatQueries } from '@legacy/utils/url';
import { IAddedValueBarPerMonth } from '../../types/addedValuePerMonth';

const GET_ADDED_VALUE_BAR_PER_MONTH_WIDGET_URL_PATH =
  '/api/v2/insights-service/hour-kpi-bar-per-month';
const GET_ADDED_VALUE_BAR_PER_MONTH_WIDGET_MSW_STATUS_KEY =
  'getAddedValueBarPerMonthAPI';

const GET_ADDED_VALUE_BAR_PER_MONTH_WIDGET_KEY =
  'GET_ADDED_VALUE_BAR_PER_MONTH_WIDGET_KEY';

const getAddedValueBarPerMonthReportingWidget = (
  filterId: string,
): Promise<IAddedValueBarPerMonth> =>
  getFetch({
    path: `${GET_ADDED_VALUE_BAR_PER_MONTH_WIDGET_URL_PATH}${concatQueries([
      { param: 'filter', value: filterId },
    ])}`,
    key: GET_ADDED_VALUE_BAR_PER_MONTH_WIDGET_MSW_STATUS_KEY,
  });

export const useGetAddedValueBarPerMonthReportingWidget = (
  filterId: string,
) => {
  const { data, isError, ...restProps } = useQuery({
    queryKey: [GET_ADDED_VALUE_BAR_PER_MONTH_WIDGET_KEY, filterId],
    queryFn: () => getAddedValueBarPerMonthReportingWidget(filterId),
  });

  if (data?.properties) {
    const { hourKPIPerMonths } = data.properties.data;
    return {
      widgetName: data.properties.type,
      widgetData: hourKPIPerMonths,
      currencyAbb: data.properties.baseCurrencyAbb,
      isError: false,
      isEmpty: hourKPIPerMonths.length <= 0,
      ...restProps,
    };
  }

  return {
    widgetName: '',
    widgetData: [],
    currencyAbb: '',
    isError: false,
    isEmpty: true,
    ...restProps,
  };
};
